import { DWMergeColumnTable } from 'src/components/merge-column-table';
import { registerExtComponent } from '@alife/cn-lowcode-utils';

registerExtComponent(DWMergeColumnTable.displayName, DWMergeColumnTable);

export default DWMergeColumnTable;
export { DWMergeColumnTable };
